import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import orderGateHook from '../../api/orderGateHook';
import PaymentStatusCard from '../../components/cards/payment-status-card';
import Spinner from '../../components/spinner/spinner';
import useDeviceInfo from '../../helpers/deviceDetect';
import getOrganizationById from '../../helpers/getOrganization';
import getPromotionalEventRedirectUrl from '../../helpers/getPromotionalEventRedirectUrl';

function PaymentDetails() {
  const [status, setStatus] = useState('pending');
  const { device, isWebView } = useDeviceInfo();
  const [bill, setBill] = useState({
    invoiceStatus: 'pending',
  });
    // console.log(status, 'status')
  const { transactionId, orgId } = useParams();
  const baseOrganizationData = getOrganizationById({ orgId });
  const [data, loading, error] = orderGateHook.useGetPaymentStatus({ preInvoiceId: transactionId, orgId });
  // Success and failure part ways for a promotional event: a paid registration is
  // finished, so Continue goes to the event's thank-you page, while a failed one
  // goes back to the event page to try again.
  const promotionalEventRedirect = getPromotionalEventRedirectUrl({
    organizationData: baseOrganizationData,
    order: data?.order,
  });
  const organizationData = promotionalEventRedirect
    ? {
      ...baseOrganizationData,
      redirect: {
        successURL: promotionalEventRedirect.successUrl,
        failureURL: promotionalEventRedirect.failureUrl,
      },
    }
    : baseOrganizationData;
    // console.log(organizationData, 'organizationData');

  function callPageFunction(orderStatus) {
    const callbackVal = orderStatus === 'paid';
    if (isWebView && device === 'android') {
      // eslint-disable-next-line no-undef
      Android.onPaymentCompletionPageOpened(callbackVal);
    }
    // console.log(orderStatus, 'orderStatus');
  }

  useEffect(() => {
    setBill(data.prePaymentInvoice);
    if (!loading) {
      callPageFunction(data?.prePaymentInvoice?.invoiceStatus);
    }
  }, [loading]);

  useEffect(() => {
    if (bill.invoiceStatus === 'paid') {
      setStatus('success');

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'purchase',
        transaction_id: transactionId,
        value: Number(bill?.totalPayable),
        status,
        isTestServer: process.env.REACT_APP_PUBLIC_ENV !== 'PROD',
        currency: 'INR',
      });
    }

    if (bill.invoiceStatus === 'cancelled') {
      setStatus('failure');
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'purchase',
        transaction_id: transactionId,
        value: Number(bill?.totalPayable),
        status,
        isTestServer: process.env.REACT_APP_PUBLIC_ENV !== 'PROD',
        currency: 'INR',
      });
    }
  }, [bill]);

  const handleRedirect = () => {
    if (isWebView && device === 'android') {
      if (status === 'success') {
        // eslint-disable-next-line no-undef
        Android.onPaymentCompleted(true);
      } else {
        // eslint-disable-next-line no-undef
        Android.onPaymentCompleted(false);
      }
    } else if (isWebView && device === 'ios') {
      if (status === 'success') {
        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.callbackHandler) {
          window.webkit.messageHandlers.callbackHandler.postMessage('iosPaymentCompleted'); // iOS-specific function call
        }
      } else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.callbackHandler) {
        window.webkit.messageHandlers.callbackHandler.postMessage('iosPaymentFail'); // iOS-specific function call
      }
    } else if (status === 'success') {
      window.location.href = organizationData.redirect.successURL;
    } else {
      window.location.href = organizationData.redirect.failureURL;
    }
  };

  const handleUpdateStatus = (statusValue) => {
    setStatus(statusValue);
  };

  return (

    <>
      {!loading && !error
                && (
                <PaymentStatusCard
                  orgId={orgId}
                  handleUpdateStatus={handleUpdateStatus}
                  handleRedirect={handleRedirect}
                  status={status}
                  transactionId={transactionId}
                  organizationData={organizationData}
                />
                )}
      {loading && !error && <Spinner fullPage />}
    </>

  );
}

export default PaymentDetails;
